import { useHasLogtoRole } from '@/hooks/useHasLogtoRole';
import { useOspite } from '@/hooks/useOspite';

/**
 * «Chi puo' entrare in QBridge»: beta OPPURE ospite (L-3002). UN predicato solo, estratto da `CancelloBridge` (K9a) perche' lo usa anche la
 * tessera della Hub (L-3011 (a)): due copie divergerebbero, e un loggato SENZA beta sulla tessera finirebbe su `RoleRequired`, un vicolo cieco.
 */
export function useBridgeAperto(): boolean {
  const beta = useHasLogtoRole('beta');
  const ospite = useOspite();
  return beta || ospite;
}
